import React from "react";
import "./about.css";

const AboutUs = () => {
  return (
    <section style={{ marginTop: "70px", height: "70vh" }}>
      <div className="d-flex h-100">
        <div className="flex_2">
          <a href="#Mission">Mission</a>
          <a href="#Features">Production Features</a>
          <a href="#Halal">Halal</a>
          <a href="#Slaughter">Slaughter</a>
          <a href="#Service">Service</a>
          <a href="#Orders">Online Orders</a>
        </div>
        <div className="overflow-auto flex_8">
          <article>
            <h5 id="Mission">Mission</h5>
            <p>
              To provide quality, authentic, hand slaughtered halal products,
              which are government inspected, and available to the customer at a
              competitive price. Sheik Halal Farms is approved and certified by
              Halal Monitoring Authority Canada ( HMA ).
            </p>
          </article>
          <article>
            <h5 id="Features">Production Features</h5>
            <ul>
              <li>
                The work philosophy at the SHF is that we are blessed when we
                can provide a trustworthy and quality food product, fair prices,
                and convenience to our customers
              </li>
              <li>
                The main emphasis in the entire production process is on three
                aspects: Halal, Quality, and Affordability
              </li>
              <li>
                The slaughtering is done strictly as per the Islamic laws by
                following the Holy Qur’anand the way of the Sunnah way of the
                Prophet Muhammad (may God’s peace be upon him)
              </li>
              <li>
                Halal products not only come with a reassurance of the Islamic
                values, but also thepromise of healthier and better quality food
                products in comparison with that slaughtered by normal methods
              </li>
              <li>
                The poultry products are processed at our slaughter house in
                Grand Valley, Ontario which includes Gaming birds, Ducks, Heavy
                Hens, Roosters, Chicken and Fowls
              </li>
              <li>Each bird is hand slaughtered one at time</li>
              <li>
                Fresh beef, lamb and goat products are purchased only from
                reputable halal abattoirs. The animals are never shot before
                hand slaughtered, ensuring a true halal product.
              </li>
              <li>
                The frozen meat products are purchased from several leading
                foreign companies from countries like Australia and New Zealand
                to provide our consumer with the best available product
              </li>
              <li>
                Every product goes through extensive testing and observation.
                The consumer canrest assured that they are receiving a quality,
                healthy product
              </li>
            </ul>
          </article>
          <article>
            <h5 id="Halal">Halal</h5>
            <p>
              Halal is an Arabic term meaning “permissible” Or lawful. To
              Muslims, the word has a larger meaning, but in the context of
              food, it refers to what may be consumed by Muslims in accordance
              with Islamic Law or Shariah. The opposite or antonym of Halal is
              Haram or forbidden. For the meat of animals to be halal, it must
              have been slaughtered according to Shariah. The hand slaughtered
              animal is referred to as Dhabihah (Zabihah) in Islam, and is
              regulated by a set rules that assure the health of the animal to
              be slaughtered and conformance to Islamic religious law, which is
              derived from the Holy Qur’an and Sunnah (way of the Prophet
              Muhammad, may God’s peace be upon him) as found in the books of
              Hadith complied by Imam Bukhari, Imam Muslim and others.
            </p>
          </article>
          <article>
            <h5 id="Slaughter">Slaughter</h5>
            <p>
              Mentioning the name of Allah should, according to the Qur’an,
              precede the act of slaughtering itself. Invoking the name of Allah
              at the moment of slaughtering is interpreted as acknowledgment of
              God’s right over all things. Furthermore, it is an asking of
              permission to take the life of the animal to be slaughtered and
              endows the slaughterer with a sense of gratitude for Allah’s
              creation, even prior to partaking in the meat of the animal. Thus,
              the slaughter itself is preceded by the words “Bismillah,
              AllahuAkbar”,which means ‘In the Name of God, God is Supreme’.
            </p>
            <p>
              According to Islamic law, the conventional method used to
              slaughter the animal involves cutting the coronary arteriesalong
              with the jugular veins with one swipe of a non-serrated, sharp
              blade. This method of slaughter serves two goals. It provides for
              a painless death, as the immediate loss of blood flow to the brain
              renders the animal unconscious and it also effectively drains the
              blood from the animal. This is important because the consumption
              of blood itself is forbidden in Islam. Muslims consider this
              method of killing the animal to be cleaner and more merciful to
              the animal.
            </p>
          </article>
          <article>
            <h5 id="Service">Service</h5>
            <ul>
              <li>
                There is a growing demand for Halal meat due to the
                diversification of the Canadian population, and the growing
                global Muslim population.
              </li>
              <li>
                Currently there are about 1.3 million Muslims in Canada.As the
                Muslim population in Canada expands and as demand from
                non-Muslim consumers grows, the halal market is expected to see
                even greater growth in the future.
              </li>
              <li>
                Canadian consumers are also becoming increasingly concerned
                about the treatment of animals before they are slaughtered, and
                are turning to halal foods as viable alternatives.
              </li>
              <li>
                Over the years, many non-Muslim consumers, who do not follow
                these religious dietary guidelines, are beginning to buy halal
                products as they are considered to be safer and of higher
                quality, taste and freshness than conventional products.
              </li>
              <li>
                There’s a growth in demand for Halal meat, particularly within
                the food service sector.
              </li>
              <li>
                This demand has become so great that they are poised to surpass
                organic meat markets in popularity.
              </li>
              <li>
                The majority of halal meat products are labelled halal but are
                not authentic hand slaughtered halal.
              </li>
            </ul>
          </article>
          <article style={{ paddingBottom: "300px" }}>
            <h5 id="Orders">Order</h5>
            <div>
              Very convenient way to purchase – Online – Save time, energy and
              efforts! By keeping with the changing times and lives becoming
              busier, SHF has started this unique initiative to bring the
              quality halal meat to your doorsteps by ONLINE ORDERS. Now the
              fresh, healthy and quality halal meat is just a click away from
              you. The distinctive features of this service are as following:
            </div>
            <ul>
              <li>Fresh as just purchased</li>
              <li>The certifications to ensure your trust</li>
              <li>
                Most authentic Halal meat hand-slaughtered by following Islamic
                traditions and the principles of Qur’an strictly
              </li>
              <li>
                Get value for money – through low price guaranteed and price
                squeezes for wholesale orders.
              </li>
            </ul>
            <div style={{ color: "orange", fontSize: "18px" }}>
              Note： online payment option coming soon{" "}
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
